import React, { useState } from 'react';
import axios from 'axios';
import { getAccessToken } from '../store/actions/auth';
import API_BASE_URL from '../config/baseUrl';
import { toast } from 'react-toastify';

const CloseIcon = () => (
  <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
    <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
  </svg>
);

const SelfDepositModal = ({ isOpen, onClose }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async function(e) {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (!amount || parseFloat(amount) <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }

    setLoading(true);

    try {
      const token = getAccessToken();
      if (!token) {
        toast.error('No access token found, please login again');
        setLoading(false);
        return;
      }

      const response = await axios.post(
        API_BASE_URL + '/superadmin/self-deposit',
        {
          amount: parseFloat(amount)
        },
        {
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.status) {
        toast.success('Amount deposited successfully');
        setAmount('');
        
        setTimeout(function() {
          onClose();
          window.location.reload();
        }, 2000);
      } else {
        toast.error('Failed to deposit amount');
      }
    } catch (err) {
      toast.error('Failed to deposit amount');
    } finally {
      setLoading(false);
    }
  };

  const handleReturn = function() {
    setAmount('');
    setError('');
    setSuccess('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50"
        onClick={handleReturn}
      ></div>

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div 
          className="bg-white rounded-lg shadow-2xl w-full max-w-md"
          onClick={function(e) { e.stopPropagation(); }}
        >
          {/* Header */}
          <div className="flex bg-[#0F2327] items-center justify-between px-6 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-white">Self Deposit</h2>
            <button
              onClick={handleReturn}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Body */}
          <div className="p-6">
            <form onSubmit={handleSubmit}>
              {/* Success Message */}
              {success && (
                <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded text-sm">
                  {success}
                </div>
              )}

              {/* Amount Input */}
              <div className="mb-6">
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Enter Coins"
                  value={amount}
                  onChange={function(e) { setAmount(e.target.value); }}
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
                  required
                />
              </div>

              {/* Buttons */}
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={handleReturn}
                  className="flex-1 px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
                  disabled={loading}
                >
                  Return
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelfDepositModal;